import React from "react";
import { Helmet } from "react-helmet";

const Terms = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>Terms and Conditions | AAMSchool</title>
        <link rel="canonical" href="https://www.aamschool.in/terms" />
        <meta
          name="description"
          content="Read the AAMSchool Terms and Conditions for website usage, content limitations, and user responsibilities."
        />
        <meta property="og:title" content="Terms and Conditions | AAMSchool" />
        <meta
          property="og:description"
          content="Read the AAMSchool Terms and Conditions for website usage, content limitations, and user responsibilities."
        />
        <meta property="og:url" content="https://www.aamschool.in/terms" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Terms & Conditions</h1>
      <p className="page-lead">
        These Terms and Conditions govern the use of AAMSchool Naukari. By using this website, you
        agree to use the content responsibly and lawfully.
      </p>

      <section className="page-policy-section">
        <h2>Use of This Website</h2>
        <p>
          By accessing AAMSchool Naukari, you agree to use the website lawfully and responsibly.
          The content published here is intended for informational and educational purposes only.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Content and Verification</h2>
        <p>
          We do not guarantee absolute accuracy or reliability of every job or exam-related detail.
          Users must verify dates, eligibility, fees, official instructions, and related notices
          from the original authority before taking action.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>User Responsibility</h2>
        <p>
          Users are responsible for how they use the information published on the site. Any action
          related to applications, payments, registration, document submission, or preparation
          planning should be completed only after checking the official source.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Content Protection and Updates</h2>
        <p>
          Unauthorized copying or reproduction of content without permission is prohibited. We may
          update, reorganize, remove, or improve content and features at any time as the site
          evolves. Continued use of the website after such changes means you accept the updated
          terms.
        </p>
      </section>
    </div>
  );
};

export default Terms;
